/* tslint:disable */
/* eslint-disable */
/**
 * API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ListMeta } from './ListMeta';
import {
    ListMetaFromJSON,
    ListMetaFromJSONTyped,
    ListMetaToJSON,
} from './ListMeta';
import type { Token } from './Token';
import {
    TokenFromJSON,
    TokenFromJSONTyped,
    TokenToJSON,
} from './Token';

/**
 * 
 * @export
 * @interface ListToken200Response
 */
export interface ListToken200Response {
    /**
     * 
     * @type {ListMeta}
     * @memberof ListToken200Response
     */
    meta: ListMeta;
    /**
     * 
     * @type {Array<Token>}
     * @memberof ListToken200Response
     */
    objects: Array<Token>;
}

/**
 * Check if a given object implements the ListToken200Response interface.
 */
export function instanceOfListToken200Response(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "meta" in value;
    isInstance = isInstance && "objects" in value;

    return isInstance;
}

export function ListToken200ResponseFromJSON(json: any): ListToken200Response {
    return ListToken200ResponseFromJSONTyped(json, false);
}

export function ListToken200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListToken200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'meta': ListMetaFromJSON(json['meta']),
        'objects': ((json['objects'] as Array<any>).map(TokenFromJSON)),
    };
}

export function ListToken200ResponseToJSON(value?: ListToken200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'meta': ListMetaToJSON(value.meta),
        'objects': ((value.objects as Array<any>).map(TokenToJSON)),
    };
}

